import { createSlice } from '@reduxjs/toolkit';
import { sliceName } from '../../../constants';
import { vehicleRegistrationInitialState } from '../../initialStates';
var ownerSlice = createSlice({
    name: sliceName.ownerDetailSliceName,
    initialState: vehicleRegistrationInitialState.intialUserState,
    reducers: {
        setOwnerDetails: function (state, action) {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.userAlias = action.payload.userAlias;
        },
    },
});
export var setOwnerDetails = ownerSlice.actions.setOwnerDetails;
export var ownerReducer = ownerSlice.reducer;
